import type { CSSProperties, MouseEventHandler, ReactNode } from 'react';

import { iconButton } from './styles.css';

export interface HeaderIconProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
}

export const HeaderIcon = (props: HeaderIconProps) => {
  const { children, onClick, style } = props;
  return (
    <button className={iconButton()} onClick={onClick} style={style}>
      {children}
    </button>
  );
};
